export default __webpack_public_path__ + "static/media/azuredevops.c9ad14da.svg";